import { generateCarleadCreationConfig } from '@wkda/funnel-utils';
import { DEFAULT_CARLEAD_CONFIGS } from '@wkda/marketing-components';

const defaultConfig = DEFAULT_CARLEAD_CONFIGS['nl-NL'];

const extendedCarleadCreationConfig = {
  ...defaultConfig,
  marketingAttributes: {
    ...defaultConfig.marketingAttributes,
    'lead-conversational-lead-toggle': 0,
  },
};

export default generateCarleadCreationConfig(extendedCarleadCreationConfig);
